import React from 'react';

import { Box, Typography } from '@mui/material';
import cx from 'classnames';

import { DEFAULT_DISCOVER_URL } from '../../const';
import { BREAKPOINTS_VALUES } from '../../theme';
import { useIsIE } from '../../utils/hooks';
import { ConditionalLink } from '../ConditionalLink';
import { LazyLoadImage } from '../LazyloadImage';
import useStyles from './styles';

export type ExpertCardType = 'light' | 'dark';

const defaultSrcset = [
  { width: 215, height: 215, focus: 'auto' },
  { width: 365, height: 365, focus: 'auto' },
  { width: 220, height: 310, focus: 'auto' },
];
const defaultSizes = `(max-width:${BREAKPOINTS_VALUES['sm']}px) 215px, (max-width: ${BREAKPOINTS_VALUES['md']}) 365px, 500px`;
const defaultTransformation = [
  {
    width: 220,
    height: 310,
    focus: 'auto',
  },
];

interface ExpertCardProps {
  title?: string;
  jobTitle?: string;
  imageUrl?: string;
  slug?: string;
  wrapperClass?: string;
  srcset?: any;
  sizes?: string;
  transformation?: any;
  withLink?: boolean;
  type?: ExpertCardType;
}

const ExpertCard: React.FC<ExpertCardProps> = ({
  title,
  jobTitle,
  imageUrl,
  slug,
  wrapperClass,
  srcset = defaultSrcset,
  sizes = defaultSizes,
  transformation = defaultTransformation,
  withLink = false,
  type = 'light',
}) => {
  const classes = useStyles(type)();

  //check on IE browser to replace srcset with custom image transformation
  const isIE = useIsIE();

  return (
    <Box className={cx(classes.wrapper, wrapperClass)}>
      <Box className={cx(classes.container)}>
        <ConditionalLink
          to={`${DEFAULT_DISCOVER_URL}/experts/${slug}`}
          className={classes.link}
          withLink={withLink}
        >
          <Box className={classes.imgWrapper}>
            {imageUrl && (
              <LazyLoadImage
                className={classes.img}
                path={imageUrl}
                alt={title}
                srcset={srcset}
                transformation={isIE ? transformation : null}
                sizes={sizes}
                data-object-fit="cover"
                imageWrapperClass={classes.imgLazyWrapper}
              />
            )}
          </Box>
        </ConditionalLink>
        <Box className={classes.textWrapper}>
          <ConditionalLink
            withLink={withLink}
            to={`${DEFAULT_DISCOVER_URL}/experts/${slug}`}
            className={classes.link}
          >
            <Typography variant="h3" className={classes.title}>
              {title}
            </Typography>
          </ConditionalLink>
          <Typography className={classes.jobTitle}>{jobTitle}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ExpertCard;
